<template>
	<v-card
		color="primary"
		tile
		flat
		:max-width="!$vuetify.breakpoint.mdAndDown ? '80%' : '100%'"
		:width="!$vuetify.breakpoint.mdAndDown ? '80%' : '100%'"
	>
		<v-img
			height="200"
			:src="isPending ? investment.imageurl : investment.package.imageurl"
		>
			<div class="fill-height bottom-gradient"></div>
		</v-img>

		<div class="py-4 px-5 text-justify">
			<div class="text-h6 font-weight-bold white--text mt-3">
				{{ Number(investment.roi) }}% for
				{{ isPending ? investment.duration : investment.package.duration }}
				months
				<div v-if="!isPending">
					({{ isPending ? investment.expectedslots : investment.slots }} Unit{{
						isPending
							? investment.expectedslots > 1
								? "s"
								: ""
							: investment.slots > 1
							? "s"
							: ""
					}})
				</div>
			</div>
			<div class="d-flex justify-space-between mt-2" v-if="!isPending">
				<div>
					<div class="white--text text-h7 font-weight-medium">Amount</div>
					<div class="success--text text-caption">{{ formattedAmount }}</div>
				</div>

				<div class="text-right">
					<div class="white--text text-h7 font-weight-medium">Total Amount</div>
					<div class="secondary--text text-caption">
						{{ formatMoney(totalAmount) }}
					</div>
				</div>
			</div>
			<v-card
				height="8px"
				class="rounded-pill mt-2"
				flat
				v-if="!isPending"
				color="white"
				width="100%"
			>
				<v-card
					height="8px"
					flat
					:width="`${(investment.daysSoFar / investment.totalDays) * 100}%`"
					color="secondary"
					class="rounded-pill"
				></v-card>
			</v-card>
			<div class="d-flex justify-space-between mt-2">
				<div>
					<div class="white--text text-h7 font-weight-medium">Acquired:</div>
					<div class="success--text text-caption">
						{{
							formatDate(isPending ? investment.updatedat : investment.start)
						}}
					</div>
				</div>

				<div class="text-right" v-if="!isPending">
					<div class="white--text text-h7 font-weight-medium">Matures</div>
					<div class="secondary--text text-caption">
						{{ formatDate(investment.maturity) }}
					</div>
				</div>
			</div>
		</div>
	</v-card>
</template>

<script>
	import { formatMoney, formatDate } from "@/utils/helpers";

	export default {
		props: {
			investment: {
				type: Object,
			},
			isPending: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				formatDate,
				formatMoney,
			};
		},
		computed: {
			amountInvested() {
				return Number(this.investment.amount ?? 0);
			},
			totalAmount() {
				return Number(
					(this.amountInvested * this.investment.roi) / 100 +
						Number(this.amountInvested)
				);
			},
			formattedAmount() {
				// convert from kobo to naira
				return formatMoney(this.amountInvested + this.investment.growthSoFar);
			},
		},
	};
</script>
